// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JMKzt","question":"styles_question__2cxTS","description":"styles_description__260ha"};